import React, { useCallback, useEffect, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box'

import Window from '../../dialog/Window'
import TinyButton from '../../widgets/TinyButton'
import TextEditorComponent from '../../texteditor/TextEditor'
import icons from '../../../icons'

import {
  ITextEditor_RawData,
} from '@kaidam/fc-shared/src/types/texteditor'

import {
  ILayout_Editor,
  ILayout_Cell_Props_Text,
} from '@kaidam/fc-shared/src/types/layout'

import {
  TEXT_EDITOR_HORIZONTAL_ALIGN_DEFAULT,
} from '@kaidam/fc-shared/src/constants'

const EditIcon = icons.edit

/*

  EDITOR

*/

const useStyles = makeStyles(theme => ({
  editorContainer: {
    height: '100%',
  },
}))

const TextEditor: ILayout_Editor<ILayout_Cell_Props_Text> = ({
  cell,
  options,
  triggerEdit,
  onSetEditing,
  onDeselect,
  onChange,
  onSave,
}) => {
  const [ editing, setEditing ] = useState(false)
  const [ editingValue, setEditingValue ] = useState<ITextEditor_RawData | null>(null)
  
  const classes = useStyles()

  const {
    text,
  } = cell.data

  const horizontalAlign = cell.config?.horizontal_align || TEXT_EDITOR_HORIZONTAL_ALIGN_DEFAULT
  const padding = cell.config?.padding || 1

  const onEdit = useCallback(() => {
    setEditing(true)
    onSetEditing(true)
    setEditingValue(text)
  }, [
    text,
  ])

  const onCancelEdit = useCallback(() => {
    setEditing(false)
    onSetEditing(false)
    setEditingValue(null)
    onDeselect()
  }, [])

  const onSaveEdit = useCallback(() => {
    if(!editingValue) return null
    onChange({
      text: editingValue,
    })
    onCancelEdit()
  }, [
    onChange,
    editingValue,
  ])

  useEffect(() => {
    if(triggerEdit) onEdit()
  }, [
    triggerEdit,
  ])

  return (
    <Box>
      {/* <TinyButton
        size="small"
        color="secondary"
        sx={{
          my: 1,
        }}
        onClick={ onEdit }
      >
        Edit Text
      </TinyButton> */}
      {
        editing && (
          <Window
            open
            size="lg"
            withCancel
            fullHeight
            noScroll
            compact
            submitTitle="Update"
            onCancel={ onCancelEdit }
            onSubmit={ onSaveEdit }
          >
            <Box className={ classes.editorContainer }>
              <TextEditorComponent
                value={ editingValue }
                options={{
                  horizontalAlign,
                  padding,
                  textMagicTags: options.textMagicTags,
                  linkMagicTags: options.linkMagicTags,
                  linkTypes: options.linkTypes,
                  publicFiles: options.publicFiles,
                  sharedFiles: options.sharedFiles,
                }}
                onChange={ (value: any) => setEditingValue(value) }
              />
            </Box>
          </Window>
        )
      }
    </Box>
  )
}

export default TextEditor